import { render } from "./DeclarationThankyou.vue?vue&type=template&id=6f687b4c&ts=true"
import script from "./DeclarationThankyou.vue?vue&type=script&lang=ts"
export * from "./DeclarationThankyou.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__